// extracted by mini-css-extract-plugin
export default {"tandc":"shipping_tandc__c+qKb","container":"shipping_container__t3lFK","policyContent":"shipping_policyContent__yvgqQ"};